export default __webpack_public_path__ + "static/media/delievers12.68cadee8.jpeg";